import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Store';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import AccountPasswordComponent from './component/AccountPasswordComponent';
import AccountSettingsComponent from './component/AccountSettingsComponent';
import css from './account.module.scss';
import AccountCalendarEventComponent from './component/AccountCalendarEventComponent';
import { ProfileInfo } from '../../types/Types';
import { useWhoamiMutation } from '../../api/LoginAPI';

/**
 * @author noone
 */
export default function AuftragSearch() {

    const navigate = useNavigate();

    const auth = useSelector((state: RootState) => state.authSlice.auth);

    const [whoamiAPI] = useWhoamiMutation();

    const [view, setView] = useState<'password' | 'settings' | 'calendarEvents'>('password');
    const [intern, setIntern] = useState<boolean>(false);
    const [whoami, setWhoami] = useState<ProfileInfo>();

    useEffect(() => {
        whoamiAPI().unwrap()
            .then(data => setWhoami(data))
            .catch((e) => console.log(e));
    }, [whoamiAPI]);

    useEffect(() => {
        if (
          whoami?.rollen.includes("admin")
          || whoami?.rollen.includes("office")
          || whoami?.rollen.includes("aussendienst")
        ) {
          setIntern(true);
        }
      }, [whoami]);

    return (
        <>
            <LandingpageHeader />

            <div className="container-fluid">

                <div className={css.accountContainer}>
                    <div>
                        <button
                            onClick={() => {
                                navigate({
                                    pathname: "/",
                                    search: ""
                                });
                            }}

                            style={{ marginBottom: "20px" }}
                            className=' btn btn-outline-primary'
                        >
                            <i className="bi bi-house"></i>
                        </button>


                        <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>
                            <button className="btn btn-outline-primary" onClick={() => setView('password')}>Passwort</button>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>
                            <button className="btn btn-outline-primary" onClick={() => setView('settings')}>Einstellungen</button>
                        </div>
                        {intern &&
                            <>
                                <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>
                                    <button className="btn btn-outline-primary" onClick={() => setView('calendarEvents')}>Persönliche Termine</button>
                                </div>
                            </>
                        }
                    </div>
                    <div>

                        <h3>Konto: {auth.user?.email}</h3>

                        {view === 'password' &&
                            <AccountPasswordComponent />
                        }
                        {view === 'settings' &&
                            <AccountSettingsComponent />
                        }
                        {view === 'calendarEvents' &&
                            <AccountCalendarEventComponent />
                        }
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );

}